import { useState } from "react";
import { Button } from "@/components/catalyst/Button";
import {
	Dialog,
	DialogActions,
	DialogBody,
	DialogDescription,
	DialogTitle,
} from "@/components/catalyst/Dialog";
import { Field, Label } from "@/components/catalyst/Fieldset";
import { Input } from "@/components/catalyst/Input";

export function ConfirmPasswordDialog({
	isOpen,
	onClose,
	onConfirm,
	title = "Verify Password",
	description = "Please enter your current password to continue.",
	isPending,
}: {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: (password: string) => void;
	title?: string;
	description?: string;
	isPending?: boolean;
}) {
	const [password, setPassword] = useState("");

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		onConfirm(password);
		// Note: We don't reset password here immediately, parent might keep dialog open on error
	};

	return (
		<Dialog open={isOpen} onClose={onClose}>
			<DialogTitle>{title}</DialogTitle>
			<DialogDescription>{description}</DialogDescription>
			<DialogBody>
				<form id="verify-password-form" onSubmit={handleSubmit}>
					<Field>
						<Label>Current Password</Label>
						<Input
							type="password"
							name="password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required
							autoComplete="current-password"
							autoFocus
						/>
					</Field>
				</form>
			</DialogBody>
			<DialogActions>
				<Button plain onClick={onClose} disabled={isPending}>
					Cancel
				</Button>
				<Button
					type="submit"
					form="verify-password-form"
					disabled={isPending || !password}
				>
					{isPending ? "Verifying..." : "Confirm"}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
